import { ActionIcon, CopyButton, Paper, Text, Tooltip } from '@mantine/core';
import { CheckIcon, CopyIcon } from '@phosphor-icons/react';
import { useStrings } from '@/i18n/useLang';

/** Single-line secret (password/passphrase) display with a copy affordance. */
export function SecretOutput({ value }: { value: string }) {
  const t = useStrings();

  return (
    <Paper
      withBorder
      radius="md"
      p="md"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '0.75rem',
        background: 'var(--bg-input)',
        borderColor: 'var(--border-light)',
      }}
    >
      <Text
        component="output"
        style={{
          flex: 1,
          fontFamily: 'monospace',
          fontSize: '1.15rem',
          wordBreak: 'break-all',
          color: 'var(--text)',
          userSelect: 'all',
        }}
      >
        {value || ' '}
      </Text>
      <CopyButton value={value} timeout={1500}>
        {({ copied, copy }) => (
          <Tooltip label={copied ? t.pw.copied : t.pw.copy} withArrow>
            <ActionIcon
              variant="subtle"
              color="cyan"
              size="lg"
              onClick={copy}
              aria-label={t.pw.copy}
              disabled={!value}
            >
              {copied ? <CheckIcon size={20} /> : <CopyIcon size={20} />}
            </ActionIcon>
          </Tooltip>
        )}
      </CopyButton>
    </Paper>
  );
}
